export default class perfilformacioncontroller{

    constructor($scope,$uiGridConstants,$http,perfilSrv,ngNotify,$cookies,UserInfoConstant,moment,$stateParams,$state,$window,SERVICE_URL_CONSTANT){
        this.$scope = $scope;
        this.$uiGridConstants = $uiGridConstants;
        this.$http = $http;
        this.perfilSrv = perfilSrv;
        this.ngNotify = ngNotify;
        this.$cookies = $cookies;
        this.$scope.UserInfoConstant = UserInfoConstant;
        this.moment = moment;
        this.$window = $window;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.downloadFileSrv = SERVICE_URL_CONSTANT.rosario + "/perfil/downloadFileCV";
        this.slick = {
            viewData: [],
            viewLoaded: false, 
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
            carouselResponsiveBreakpoints: [
              {
                breakpoint: 1000,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }, {
                breakpoint: 1200,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2
                }
              }, {
                breakpoint: 1920,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3
                }
              }, {
                breakpoint: 3000,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 4
                }
              }
            ]
        }        
        this.$scope.$watch('UserInfoConstant[0].details[0]', (details) => {
            if (details !== undefined) {
                this.userinfo = details.user;
                this.userinfo.role_id = this.$cookies.get('hasRoleId');
                this.main();
            }
        });
    }

    main() {
        /**
        * Si no se ha especificado un teacherId, verifica el tipo de Role y si es Docente le buscar su respectivo teacherId
        **/
        if (this.$stateParams.teacherId != '') {
            this.userinfo.teacherId = this.$stateParams.teacherId;
            this.perfilFormacion(this.userinfo.teacherId);
        } else {
            this.perfilSrv.role.getType({param1: this.userinfo.role_id}).$promise.then((response) => {
                if (!response.status) {
                    this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
                } else {
                    this.role = response.data[0];
                    if (this.role.types == 'TEACHER') {
                        this.getInfo();
                    } else {
                        this.$state.go('profile.perfil_dash');
                        this.ngNotify.set('No se ha especificado ningún docente', 'info');
                    }
                }
            }, (err) => {
                this.ngNotify.set('Imposible conectar con el servicio', 'error');
            });
        }
    }

    goBack(){
        this.$state.go('profile.perfil_dash', {teacherId:this.$stateParams.teacherId})
    }

    getInfo() {
        this.perfilSrv.role.getInfo({param1: this.userinfo.id}).$promise.then((response) => {
            if (!response.status) {
                this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
            } else {
                this.userinfo.teacherId = response.data[0].idTeacher;
                this.perfilFormacion(this.userinfo.teacherId);
            }
        }, (err) => {
            this.ngNotify.set('Imposible conectar con el servicio', 'error');
        });
    }

    download(item){
        var documentPath = item.document_url;
        documentPath = documentPath.replace(/\//g, ',');
        let params = {
            rut: item.id_rut,
            fileName: item.document_suport,
            filePath: documentPath
        }

        this.$window.open(this.downloadFileSrv+"/"+params.rut+"/"+params.filePath+"/"+encodeURIComponent(params.fileName) )
    }

    perfilFormacion(teacherId) {
        this.slick.viewLoaded = false;
        this.perfilSrv.perfildocente.perfilFormacion({teacherId:teacherId}).$promise.then((dataReturn) => {
            this.formation = dataReturn.data;
            console.log(this.formation);
            for (let i in this.formation) {
                var item = this.formation[i];

                item.end_date = (item.end_date) ? this.moment(item.end_date, 'DD-MM-YYYY').format('DD-MM-YYYY') : 'Sin especificar';
                item.Convalescence = (item.Convalescence) ? this.moment(item.Convalescence, 'DD-MM-YYYY').format('DD-MM-YYYY') : 'Sin especificar';

                item.hasSupportDoc = (item.document_suport) ? true : false;
                item.hasSupportUrl = (item.document_url) ? true : false;
                item.supportDocumentClass = (item.hasSupportDoc && item.hasSupportUrl) ? 'mdi-action-done text-verde' : 'mdi-navigation-cancel text-rojo'

                //Diferenciación tarjetas formales y no formales
                item.isFormal = (item.type === 'Formal') ? true : false; 
                item.status = (item.status) ? item.status : 'No Registra';
                item.badgeColorClass = (item.isFormal) ? 'verde' : 'gris-darker';
                item.badgeText = (item.isFormal) ? 'Estudios formales' : 'Otros estudios';

                this.slick.viewData.push(item);
            }
            this.slick.viewLoaded = true;
        }, (data) => {
            this.ngNotify.set('Imposible conectar con el servicio', 'error');
        });
    }        
}

perfilformacioncontroller.$inject = ['$scope','uiGridConstants','$http','perfilSrv','ngNotify','$cookies','UserInfoConstant', 'moment', '$stateParams', '$state','$window','SERVICE_URL_CONSTANT'];


// WEBPACK FOOTER //
// ./src/app/u-faculty/profile/perfil/perfilde_formacion/perfilformacioncontroller.js